import { combineReducers } from "redux";

import { appReducer } from "@workerhome/components/App";
import { sidebarReducer } from "@workerhome/components/Sidebar";

// Combine the App reducers and export for store creation
export default combineReducers({
  app: appReducer,
  sidebar: sidebarReducer
});



// WEBPACK FOOTER //
// ./src/workerhome/reducers.js